export default {
  items: (state) => state.items,
  itemsMeta: (state) => state.itemsMeta,
  itemsTable: (state) => state.itemsTable,
  itemsLoading: (state) => state.itemsLoading,
};
